var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-content"},[_c('h6',[_vm._v("Copyright © "),_c('a',{staticStyle:{"color":"#20a0ff"},attrs:{"href":"https://github.com/wuzhenxi520?tab=stars","target":"_blank"}},[_vm._v("JesseWu")])]),_c('h6',[_c('a',{staticStyle:{"color":"#20a0ff"},attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("鄂ICP备2021021927号")])])])
}]

export { render, staticRenderFns }